import { render, staticRenderFns } from "./NeighbourhoodLabels.vue?vue&type=template&id=79a3af1a&scoped=true&"
import script from "./NeighbourhoodLabels.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodLabels.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodLabels.vue?vue&type=style&index=0&id=79a3af1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a3af1a",
  null
  
)

export default component.exports